import React from 'react';
import Svg from '../Svg';

const IconMap01 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.4719 1.11833C22.797 1.29235 23 1.63121 23 2V18C23 18.3344 22.8329 18.6466 22.5547 18.8321L16.5547 22.8321C16.2395 23.0422 15.8327 23.0562 15.5039 22.8682L9 19.1518L2.49614 22.8682C2.18664 23.0451 1.80639 23.0438 1.49807 22.8649C1.18976 22.686 1 22.3565 1 22V6C1 5.64114 1.19229 5.3098 1.50386 5.13176L8.50386 1.13176C8.81129 0.956083 9.18871 0.956083 9.49614 1.13176L15.9595 4.82513L21.4453 1.16795C21.7522 0.96338 22.1467 0.944308 22.4719 1.11833ZM15 6.58032L10 3.72318V17.4197L15 20.2768V6.58032ZM17 20.1315L21 17.4648V3.86852L17 6.53518V20.1315ZM8 17.4197V3.72318L3 6.58032V20.2768L8 17.4197Z"
    />
  </Svg>
);

export default IconMap01;
